export default __webpack_public_path__ + "static/media/flag-sv-SE.9e52c51a.svg";